/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Filter_NoneInputs */



/**
* | output |
* | --- |
* | "Nothing selected" |
*
* @param {Agenda_Filter_NoneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_filter_none = /** @type {((inputs?: Agenda_Filter_NoneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Filter_NoneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Niets geselecteerd")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rien de sélectionné")
	return /** @type {LocalizedString} */ ("Nothing selected")
});